import request from '../tools/request'
import { HTTP } from './http'
const { GET, POST } = request

// 再次提交品牌
export const POST_RESUNBNIT_API = (params: { assessIds: string }) =>
  POST(`${HTTP}/productAssess/reSubmitAssess`, params)

// 放弃申请品牌
export const POST_GIVEUP_API = (params: { productIds: string }) =>
  POST(`${HTTP}/product/giveUpProduct`, params, 'application/json', params)

// 获取品牌操作记录
export const GET_RECORDBRANDDETAIL = (param: { brandId: string }) =>
  GET(`${HTTP}/brand/getBrandOperateRecord`, param)

// 获取工商信息
export const GET_BUSINESSINFO = (params: { supplierId: string }) =>
  GET(`${HTTP}/supplier/getMenuInfo`, params)

// 获取工商信息
export const POST_BRANDGIVEUP_API = (params: { brandId: string }) =>
  POST(`${HTTP}/supplierBrand/giveUpApply`, params, 'application/json', params)
import request from '../tools/request'
import { HTTP } from './http'
const { GET, POST } = request

// 再次提交品牌
export const POST_RESUNBNIT_API = (params: { assessIds: string }) =>
  POST(`${HTTP}/productAssess/reSubmitAssess`, params)

// 放弃申请品牌
export const POST_GIVEUP_API = (params: { productIds: string }) =>
  POST(`${HTTP}/product/giveUpProduct`, params, 'application/json', params)

// 获取品牌操作记录
export const GET_RECORDBRANDDETAIL = (param: { brandId: string }) =>
  GET(`${HTTP}/brand/getBrandOperateRecord`, param)

// 获取工商信息
export const GET_BUSINESSINFO = (params: { supplierId: string }) =>
  GET(`${HTTP}/supplier/getMenuInfo`, params)

// 获取工商信息
export const POST_BRANDGIVEUP_API = (params: { brandId: string }) =>
  POST(`${HTTP}/supplierBrand/giveUpApply`, params, 'application/json', params)
